import { Component } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthService } from '@app/services';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@UntilDestroy()
@Component({
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent {
  otpCode = '';
  isTrusted = true;
  hasError = false;
  loading = false;
  resendOtpSuccess = false;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  resendCode() {
    this.loading = true;
    this.hasError = false;
    this.resendOtpSuccess = false;

    this.authService
      .resendOtp()
      .pipe(
        catchError((err) => {
          this.hasError = true;
          this.loading = false;
          this.resendOtpSuccess = false;
          return of(err);
        }),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.hasError = false;
        this.loading = false;
        this.resendOtpSuccess = true;
      });
  }

  verify() {
    if (this.otpCode.length === 6) {
      this.loading = true;
      this.hasError = false;

      this.authService
        .verifyOtp(this.otpCode, this.isTrusted)
        .pipe(
          catchError((err) => {
            this.hasError = true;
            this.loading = false;
            if (err.status === 403) {
              this.toastr.error(this.translate.instant('login.error_otpToken'));
              this.router.navigate(['/']);
            } else if (err.status === 429) {
              this.toastr.error(this.translate.instant('login.error_ratelimitotp'));
              this.router.navigate(['/']);
            }
            return of(err);
          }),
          untilDestroyed(this),
        )
        .subscribe();
    }
  }
}
